import { Box, StyledEngineProvider } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { DesktopGlobalStyles } from '~/AppGlobalStyles';
import { LocalizedThemeProvider } from '~/components/SelectedLanguage/component';
import { ModulePageFooter } from '~/legacy-components/ModulePageFooter';
import { Topbar } from '~/legacy-components/Topbar';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { PortalViewRouter } from '~/scenes/PortalViews/router';
import { usePortalViews } from '~/scenes/PortalViews/usePortalViews';
import { theme } from '~/theme';

import { useSxStyles } from './useStyles';

export const PortalViews = () => {
  const sxStyles = useSxStyles();

  const { t } = useTranslation();
  const { isLoading, isInitializing, initializationPercentage } =
    usePortalViews();

  if (isInitializing) {
    return (
      <LoadingView>
        {t('loadingPortalView')} - {initializationPercentage}
      </LoadingView>
    );
  }

  if (isLoading) {
    return <LoadingView>{t('loading')}</LoadingView>;
  }

  return (
    <StyledEngineProvider injectFirst>
      <DesktopGlobalStyles />
      <LocalizedThemeProvider theme={theme}>
        <Box sx={sxStyles.viewContainer}>
          <Box sx={sxStyles.viewHeader}>
            <Topbar />
          </Box>
          <Box sx={sxStyles.pageContainer}>
            <PortalViewRouter />
          </Box>
          <Box sx={sxStyles.viewFooter}>
            <ModulePageFooter />
          </Box>
        </Box>
      </LocalizedThemeProvider>
    </StyledEngineProvider>
  );
};
